/* eslint sort-keys: "error" */

import { translate } from '@vimeo/i18n-runtime';

export const sharedTranslations = {
  areYouSureBlockUser: translate(
    'Are you sure you want to block this user? They will still be able to send messages but the messages will not show up to other viewers. You will be able to unblock them.',
  ),
  areYouSureDeleteMessage: translate(
    'Are you sure you want to delete this message? This action can not be undone.',
  ),
  at: 'at',
  availability: translate('Availability'),
  beta: translate('Beta'),
  blockUser: translate('Block user'),
  blur: translate('Blur'),
  blurMyBackground: translate('Blur my background'),
  cameraBackground: translate('Camera background'),
  captureLeadsAndViwerLevelInsights: translate('Capture leads and viewer-level insights'),
  copyShowcaseEmbed: translate('Copy showcase embed code'),
  copyShowcaseLink: translate('Copy showcase link'),
  customize: translate('Customize'),
  customizePlayer: translate('Customize player'),
  darkMode: translate('Dark mode'),
  debug: 'Debug',
  delete: translate('Delete'),
  deleteMessage: translate('Delete Message'),
  demoUpgradeModalFeaturesListEnterprise: [
    translate('Go live with confidence with backup streams'),
    translate('Engage with chats, polls, and moderated Q&A'),
    translate('Stream to social and other destinations'),
    translate('Drive leads with customizable registration'),
    translate('Get viewer-level analytics that connect to your CRM'),
  ],
  destinationsAreNotWithExtended: translate('Destinations are not supported with extended streams'),
  destinationsAreRestrictedByOwner: translate(
    "You don't have permission to add, delete or edit destinations",
  ),
  destinationsStreamRestrictedByOwner: translate(
    "You don't have permission to stream to other destinations",
  ),
  discard: translate('Discard'),
  dontAskAgain: translate("Don't ask again"),
  dontAskMeAgainToDelete: translate("Don't ask me again"),
  dontShowThisMessage: translate('Don’t show this message again'),
  download: translate('Download'),
  downloadChat: translate('Download chat'),
  downloadPolls: translate('Download polls'),
  downloadQna: translate('Download Q&A'),
  effects: translate('Effects'),
  enterpriseTalkToTeam: translate('Talk to our team to add registration to your Enterprise plan.'),
  eventHasEnded: translate('This event has ended'),
  eventHasNotStarted: translate('Event has not started yet'),
  eventPrivacyFrozen: translate(
    'Privacy settings cannot be changed. Contact your Account Admin for details.',
  ),
  eventPrivacyRestricted: translate(
    'Event cannot be made public. Contact your Account Admin for details.',
  ),
  everyoneCanHearYou: translate('Everyone can hear you'),
  export: translate('Export'),
  externalEncoderDescriptionSrt: translate('Go live with RTMP or SRT'),
  externalEncoderTitle: translate('Use an external encoder'),
  flipHorizontally: translate('Flip horizontally'),
  goLiveWithPeaceOfMind: translate(
    'Go live with peace of mind. If anything goes wrong with your primary stream, Vimeo will automatically switch your event to the backup stream so you don’t lose your audience.',
  ),
  id: translate('ID'),
  inActivePageMessage: translate('Your connection has been paused due to inactivity'),
  key: translate('key'),
  lightMode: translate('Light mode'),
  linkCopied: translate('Link copied'),
  manage: translate('Manage'),
  manageShowcase: translate('Manage showcase'),
  manual: translate('Manual'),
  mirrorMyVideo: translate('Mirror my video'),
  mirrorMyVideoAnnotation: translate(
    'Your video stream will be mirrored in the speakers panel and the preview window, but not in the audience stream',
  ),
  mostPopular: translate('Most popular'),
  mute: translate('Mute'),
  newMessagesReceived: translate('New messages received!'),
  newest: translate('Newest'),
  noDevices: translate('No devices'),
  noDevicesAvailable: translate('No devices available'),
  noEffects: translate('No effects'),
  noName: translate('No name'),
  noRegionalRestrictions: translate('No regional restrictions set'),
  ok: translate('Ok'),
  oldest: translate('Oldest'),
  popular: translate('Popular'),
  promptBeforePageLeave: `${translate('Leave site?')} ${translate(
    'Changes you made may not be saved.',
  )}`,
  purple: translate('Purple'),
  recent: translate('Recent'),
  recordEventFeature: translate('Record event'),
  recordEventFeatureTip: translate('Recorded events are automatically saved in the Library'),
  recordEventRequiredForDvr: translate('Record event is required for DVR'),
  recordEventUnlimitedNotSupported: translate(
    'Record event is not supported with 12+ hour streaming',
  ),
  recordingIsDeleted: translate('This recording has been deleted'),
  recordingIsEnded: translate('This recording has ended'),
  registration: translate('Registration'),
  reply: translate('Reply'),
  replyAndApprove: translate('Reply and approve'),
  requestError: translate('There was an error submitting the request. Please try again.'),
  reschedule: translate('Reschedule'),
  rtmpStream: translate('RTMP stream'),
  schedule: translate('Schedule'),
  selected: translate('Selected'),
  settings: translate('Settings'),
  share: translate('Share'),
  shareScreen: translate('Share screen'),
  showcase: translate('Showcase'),
  showcaseChangePrivacy: translate('Change privacy.'),
  showcasePrivacyNotice: translate(
    'This event is part of a showcase and will inherit its privacy settings.',
  ),
  sortBy: translate('Sort by'),
  startsInTime: (time: string) =>
    translate({
      replacements: {
        TIME: time,
      },
      singular: 'Starts in {TIME}',
    }),
  stopVideo: translate('Stop video'),
  streamID: translate('Stream ID'),
  streamId: (identificatorName: string) =>
    translate({
      replacements: {
        IDENTIFICATOR: identificatorName,
      },
      singular: 'Stream {IDENTIFICATOR}',
    }),
  streamUrl: translate('Stream URL'),
  support: translate('Support'),
  switchBack: translate('Switch back'),
  switchBackToTheOldEventsExperience: translate('Switch back to the old events experience'),
  switchToOldExperience: translate('Switch to old experience'),
  team: translate('Team'),
  theNewEventsExperienceWillBeRolledOut: translate(
    'The new events experience will be rolled out to everyone soon. You can use the old experience until then.',
  ),
  thisEventHasNotStartedYet: translate("This event hasn't started yet"),
  thisEventIsScheduledFor: translate('This event is scheduled for'),
  tier1UpgradeModalFeaturesListEnterprise: [
    translate('Customizable event registration forms'),
    translate('Branded confirmation, reminder, and thank you emails'),
    translate('Viewer-level analytics that connect to your CRM'),
  ],
  toBlurBackgroundSwitchToChrome: translate('To blur your background, switch to Chrome'),
  unblock: translate('Unblock'),
  undo: translate('Undo'),
  unknown: translate('Unknown'),
  unlimitedDurationFeature: translate('Extended stream'),
  unlimitedDurationFeatureTip: translate(
    'Stream an extended event without time limitations. Extended streams will not be recorded.',
  ),
  unlimitedNotSupportedWithArchive: translate(
    'Extended streaming is not supported with Record event',
  ),
  unlimitedNotSupportedWithDvr: translate('Extended streaming is not supported with DVR'),
  unlimitedRequiresRTMP: translate('Extended streaming is only available when streaming with RTMP'),
  unmute: translate('Unmute'),
  upgradeModalEnterpriseSubtitle: translate(
    'Host events of all kinds, from webinars to live broadcasts, team events, and more',
  ),
  upgradeToAutoCC: translate('Unlimited automatic closed captions'),
  upgradeToBackupYourStream: translate('Upgrade to back up your stream'),
  upgradeToStreamWithConfidence: translate('Upgrade to stream with confidence'),
  useYourEncoder: translate('Use your preferred encoder'),
  userWasBlocked: (name: string) =>
    translate({
      replacements: {
        NAME: name,
      },
      singular: '{NAME} was blocked!',
    }),
  view: translate('View'),
  viewersAtDestinationsWillNot: translate(
    'Viewers at destinations will not need to register to watch',
  ),
  wantToGoLiveAgain: translate(
    'Want to go live again? Reuse this event’s settings to create your next event',
  ),
};
